import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ServiceDetail from "../../../components/service/admin/serviceDetail";
import { styles } from "./styles";
import queryString from "query-string";
import Header from "../../../partials/header";
import HeaderAdmin from "../header";

class Service extends React.Component {
  componentDidMount() {
    const { adminService = {} } = this.props;
    let serviceCode = "";
    let location = this.props.location;
    const parsed = queryString.parse(location.search);
    if (location && location.state && location.state.adminService)
      serviceCode = location.state.adminService.no;
    else if (parsed.serviceCode) {
      serviceCode = parsed.serviceCode;
    } else serviceCode = adminService.no;
    this.props.getServiceByCode({ no: serviceCode });
  }
  back = () => {
    const { location = {} } = this.props;
    this.props.history.push({
      pathname: `/${
        location && location.state && location.state
          ? "user"
          : "service-admin/list"
      }`,
    });
  };
  render() {
    const { classes, t, disabled = false, ...props } = this.props;
    return (
      <>
        <HeaderAdmin {...props} />
        <Header
          session={t("service_admin_list_services")}
          title={t("service_admin_edit_spa")}
          //   backIcon={true}
          //   actionBack={() => this.back()}
        />
        <ServiceDetail {...props} disabled={disabled} />
      </>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  getServiceByCode: dispatch.service.getServiceByCode,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
